<template>
  <div>
    <chart-card :chart-data="pieChart" chart-type="Pie" :render="render">
      <template slot="header">
        <h4 class="card-title">{{title}} <i v-if="tooltip" v-tooltip.top-center="tooltip" class="fas fa-question-circle small"/></h4>
        <p class="card-category">{{subtitle}}</p>
      </template>
      <template slot="footer">
        <div class="legend row ml-0">
          <span v-for="company in $store.getters.companies" :key="company.id">
            <i :class="'fas fa-circle ct-legend-'+company.color"/>&nbsp;{{company.profile.companyName}}
            &nbsp;
          </span>
        </div>
        <hr>
        <div class="stats">
          <i class="far fa-clock"></i> This Month
        </div>
      </template>
    </chart-card>
  </div>
</template>

<script>
import {ChartCard} from 'src/components/index'
export default {
  name: 'Payouts-Pie-Chart-Multi-View-Card',
  components: {
    ChartCard
  },
  props: {
    title:        {type: String, required: false},
    tooltip:      {type: String, required: false},
    payoutStatus: {type: Object, required: false}, // status to filter on 
    render:       {type: Boolean, default: false}
  },
  computed: {
    subtitle () {
      //console.log('subtitle: ', this.$store.getters.companySelected)
      if (this.$store.getters.periodSelected) {
        return this.$store.getters.periodSelected.label
      }
      return ''
    },
    pieChart () {
      let pieChart = { labels: [], series: [] }
      let count = {}
      let total = 0
      let affiliates = this.$store.getters.affiliatesJson
      this.$store.getters.companies.forEach(company => {
        this.$store.getters.payoutsJson.forCompanyId(company.id, {affiliates}).values.forEach(payout => {
          if (!this.payoutStatus || (payout.status === this.payoutStatus.value)) {
            count[company.id] ? count[company.id] += payout.amount : count[company.id] = payout.amount
            total += payout.amount
          }
        })
      })
      Object.keys(count).forEach(companyId => {
        pieChart.labels.push(Math.round(100*count[companyId]/total) + '%')
        pieChart.series.push(Math.round(100*count[companyId]/total))
      })
      return pieChart
    }
  }

}
</script>

<style>

</style>